import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { hamaColors, hamaColorCategories } from '../data/hamaColors';

const { FiPalette, FiChevronDown, FiChevronUp } = FiIcons;

const ColorPalette = () => {
  const [expandedCategories, setExpandedCategories] = useState(['standard']);

  const toggleCategory = (category) => {
    setExpandedCategories(prev => 
      prev.includes(category) 
        ? prev.filter(c => c !== category)
        : [...prev, category]
    );
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-2xl shadow-lg p-6 border border-gray-200"
    >
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">Palette Hama</h2>
        <SafeIcon icon={FiPalette} className="w-5 h-5 text-purple-500" />
      </div>

      <div className="space-y-4">
        {hamaColorCategories.map((category) => (
          <div key={category.name} className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              onClick={() => toggleCategory(category.name)}
              className="w-full px-4 py-3 bg-gray-50 text-left flex items-center justify-between hover:bg-gray-100 transition-colors"
            >
              <div>
                <span className="font-medium text-gray-900">{category.displayName}</span>
                <span className="text-sm text-gray-500 ml-2">({category.colors.length} couleurs)</span>
              </div>
              <SafeIcon 
                icon={expandedCategories.includes(category.name) ? FiChevronUp : FiChevronDown} 
                className="w-4 h-4 text-gray-500" 
              />
            </button>
            
            {expandedCategories.includes(category.name) && (
              <div className="p-4">
                <div className="grid grid-cols-8 gap-2">
                  {category.colors.map((colorId) => {
                    const color = hamaColors.find(c => c.id === colorId);
                    if (!color) return null;
                    
                    return (
                      <div
                        key={color.id}
                        className="group relative"
                        title={`${color.name} (${color.id})`}
                      >
                        <div
                          className="w-8 h-8 rounded-lg border-2 border-gray-300 cursor-pointer transform hover:scale-110 transition-transform shadow-sm"
                          style={{ backgroundColor: color.hex }}
                        />
                        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
                          {color.name}
                          <br />
                          #{color.id}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-4 p-4 bg-yellow-50 rounded-lg">
        <h3 className="text-sm font-medium text-yellow-900 mb-2">ℹ️ Information</h3>
        <p className="text-sm text-yellow-700">
          L'algorithme sélectionne automatiquement les couleurs Hama les plus proches de votre image originale.
        </p>
      </div>
    </motion.div>
  );
};

export default ColorPalette;